<template>
  <div>
    <div class="theme-loader">
      <div class="ball-scale">
        <div class='contain'>
          <img src="../assets/loader.gif">
        </div>
      </div>
    </div>
    <div
      id="pcoded"
      class="pcoded"
    >
      <div class="pcoded-overlay-box"></div>
      <div class="pcoded-container navbar-wrapper">

        <navbar1 />

        <div class="pcoded-main-container">
          <div class="pcoded-wrapper">

            <navbar2 />

            <div class="pcoded-content">
              <div class="pcoded-inner-content">
                <div class="main-body">
                  <div
                    class="page-wrapper"
                    style="background: #fff;"
                  >

                    <div class="page-body">
                      <h4>All Openings</h4>

                      <div class="table-responsive">
                        <input
                          type="text"
                          class="form-control"
                          v-model="opening_filter"
                          placeholder="Search..."
                        >
                        <datatable
                          :columns="opening_columns"
                          :data="opening_rows"
                          :filter-by="opening_filter"
                          name="openings_table"
                          :key="table_key"
                        ></datatable>
                        <div
                          class=""
                          style="text-align: center;"
                        >
                          <datatable-pager
                            v-model="page"
                            type="long"
                            :per-page="per_page"
                            table="openings_table"
                          ></datatable-pager>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="opening in opening_rows"
      v-bind:id="'delete' + opening.id"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div
            class="modal-body"
            style="text-align: center;"
          >
            <h5>Delete opening: {{opening.role_name}}?</h5>
            <br><br>
            <button
              class="btn btn-sm btn-danger"
              v-on:click="deleteItem(opening.id)"
            >Delete</button>
            &nbsp;
            <button
              class="btn btn-sm btn-primary"
              data-dismiss="modal"
            >Cancel</button>
          </div>
        </div>
      </div>
      <div>
        <h5>You do not have permission to delete an opening.</h5>
      </div>
    </div>
    <div id="fb-root"></div>
  </div>
</template>
<style>
.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color 0.3s;
  background: #d5d5d5 !important;
}

.pagination a.active {
  background: #4caf50 !important;
  color: white;
}

.pagination a:hover:not(.active) {
  background-color: #00ff00;
}

.swal-height {
  height: 300px;
}

.btn-dribbble i,
.btn-dropbox i,
.btn-facebook i,
.btn-flickr i,
.btn-github i,
.btn-google-plus i,
.btn-instagram i,
.btn-linkedin i,
.btn-pinterest i,
.btn-skype i,
.btn-tumblr i,
.btn-twitter i,
.btn-youtube i {
  margin: 0 !important;
  padding: 0px !important;
}
</style>
<script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v4.0"></script>
<script async src="https://static.addtoany.com/menu/page.js"></script>
<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'
import Vue from 'vue'
import {mapActions, mapMutations, vuex} from 'vuex'
export default {
  name: 'AllOpenings',
  data () {
    return {
      opening_filter: '',
      page: 1,
      per_page: 10,
      table_key: 0,
      opening_columns: [
        { label: 'ID', field: 'id' },
        { label: 'Role', representedAs: (row) => {
            return row.jobrole.name
          }, interpolate: true, sortable: false
        },
        {
          label: 'Number of Fresh Applications', representedAs: (row) => {
            return (row.applicants_count > 0) ? '<a class="btn btn-sm btn-primary" href="../opening/' + row.id + '/">' + row.applicants_count + '</a>' : 'No Applications'
          }, interpolate: true, sortable: false
        },
        { label: 'Company', field: 'company_name', sortable: false },
        {
          label: 'Actions', representedAs: (row) => {
            let o_url = encodeURI('https://careers.sundryfood.com/application/' + row.id)
            return '<a + target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=' + o_url + '&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore btn btn-facebook btn-sm" title="Share to Facebook"><i class="icofont icofont-social-facebook"></i></a>&nbsp;' +
              '<a target="_blank" href="https://www.linkedin.com/sharing/share-offsite/?url=' + o_url + '" class="btn btn-linkedin btn-sm"><i class="icofont icofont-brand-linkedin" title="Share to LinkedIn"></i></a>&nbsp;' +
              '<a class="btn btn-sm btn-success" title="View Opening" href="/viewopening/' + row.id + '"><i class="icofont icofont-eye"></i></a>&nbsp;' +
              '<a class="btn btn-sm btn-info" title="Edit Opening"  href="/opening/edit/' + row.id + '"><i class="icofont icofont-pencil"></i></a>&nbsp;' +
              '<button class="btn btn-sm btn-danger" title="Delete Opening" data-toggle="modal" data-target="#delete' + row.id + '"><i class="icofont icofont-trash"></i></button>&nbsp;'

          }, interpolate: true, sortable: false
        },
      ],

      opening_rows: [
        {
          id: 'Loading...',
          jobrole: 'Loading...',
          applicants_count: 0,
          entrydate: 'Loading...'
        }
      ]
    }
  },

  components: {
    navbar1,
    navbar2
  },

  mounted () {

    this.getAllOpenings()

    //this.getRoleNameById('23')
  },

  created () {
    // window.editOpening = this.editOpening
  },

  methods: {
    ...mapMutations([
      'setOpenings'
    ]),

    // editOpening (opening) {
    //   this.$router.push('/opening/edit/'+opening);
    //   console.log('hey');
    // },

    getAllOpenings () {
      console.log(this.$store.getters.user_data.data)
      var get_openings_request = {
        what: 'openings'

      }

      this.$socket.makeGetRequest(get_openings_request)
        .then((response) => {
          if (response.type == 'openings') {
            this.$swal.close()
            this.opening_rows = response.data
            this.setOpenings(this.opening_rows);
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },

    getRoleNameById (id) {
      var getRole = {
        what: 'Opening',
        id: id
      }

      this.$socket.makeGetRequest(getRole)
        .then((response) => {
          //console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },

    deleteItem (id) {
      var loading_html = '<img src="https://d85ecz8votkqa.cloudfront.net/images/loading.gif" />'
      this.$swal.fire({
        title: "",
        html: loading_html,
        showConfirmButton: false,
        showCancelButton: false,
        width: '350px',
        customClass: 'swal-height',
        allowOutsideClick: false
      })

      var deleteReq = {
        what: 'opening',
        id: id
      }

      this.$socket.makeDeleteRequest(deleteReq)
        .then((response) => {
          if (response.type == 'opening') {
            this.$swal.close()
            $("#delete" + id).modal('hide')
            this.getAllOpenings()
            window.alert('Deleted successfully.')
          }
        })
        .catch((e) => {
          this.$swal.fire('Error', 'Sorry, an error occured', 'error')
          console.log(e)
        })
    }
  },
  computed: {

  }
}
</script>